import {useState, useCallback} from 'react';
import {RadioGroup} from 'bonprix-design-system';
import {yieldToMain} from '../ArticleOverviewHelper.js';

export default function Ordering({ordering, handleOrderingChange}) {
    const initialValue = ordering.find((option) => option.selected)?.value ?? '';
    const [selectedValue, setSelectedValue] = useState(initialValue);

    const handleOnChange = useCallback((selectedOrderingValue) => {
        const selectedOption = ordering.find((option) => option.value === selectedOrderingValue);
        if (selectedOption) {
            yieldToMain(() => setSelectedValue(selectedOrderingValue));
            handleOrderingChange(selectedOrderingValue, selectedOption.landmark, selectedOption.name);
        }
    }, [ordering, handleOrderingChange]);

    return (
        <RadioGroup
            name="orderings"
            value={selectedValue}
            onChange={handleOnChange}
            componentName="radio-group"
            label=""
        >
            {ordering.map((option) => (
                <RadioGroup.Item
                    key={option.value}
                    value={option.value}
                    label={option.name}
                />
            ))}
        </RadioGroup>
    );
}
